import { COPY_DESIGN } from "../../actions";

const initialState = {
  layersToCopy: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COPY_DESIGN.SUCCESS:
      // Layers copied from the design with the ID that matches the 'copyFrom' query string
      const layersToCopy = action.response.design.layer_set;

      // Copied layers containing text and/or images
      const copiedLayers = layersToCopy.filter((layer) => {
        return (
          layer.allow_text === true ||
          layer.allow_image === true ||
          layer.photo_image === true
        );
      });

      const copiedLayersCount = copiedLayers.length;
      let currentLayer = 0;

      return {
        ...state,
        layer_set: state.layer_set.map((layer) => {
          if (layer.allow_text || layer.allow_image || layer.photo_image) {
            let layerTextElements = [],
              layerImageElements = [];

            if (currentLayer < copiedLayersCount) {
              layerTextElements = layer.allow_text
                ? copiedLayers[currentLayer].text_elements
                : [];

              if (layer.allow_image) {
                const artAndClipart = copiedLayers[
                  currentLayer
                ].image_elements.filter((image) => image.type !== "photo");
                artAndClipart.forEach((image) => {
                  layerImageElements.push(image);
                });
              }

              if (layer.photo_image) {
                const photos = copiedLayers[currentLayer].image_elements.filter(
                  (image) => image.type === "photo",
                );
                photos.forEach((image) => {
                  layerImageElements.push(image);
                });
              }
            }

            currentLayer++;

            return {
              ...layer,
              text_elements: layerTextElements,
              image_elements: layerImageElements,
            };
          }

          return {
            ...layer,
          };
        }),
      };

    case COPY_DESIGN.FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
}
